"use strict";
/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PiclibFileUploadAllowedExtension = void 0;
exports.PiclibFileUploadAllowedExtension = {
    Png: 'png',
    Jpg: 'jpg',
    Jpeg: 'jpeg',
    Gif: 'gif',
    Pptx: 'pptx',
    Doc: 'doc',
    Xls: 'xls',
    Docx: 'docx',
    Ppt: 'ppt',
    Pdf: 'pdf',
    Xlsx: 'xlsx'
};
